import React from "react";
import PropTypes from "prop-types";
import "./ClientTableCell.scss";

const ClientTableCell = ({ item }) => {
  const client = item.clientId;
  const clientCode = client ? (client.code || "N/A") : "N/A";
  const clientColor = client?.color;

  const isValidColor = clientColor && /^#([0-9A-Fa-f]{6})$/.test(clientColor);

  return (
    <div className="client-table-cell">
      {isValidColor && (
        <span
          className="client-table-cell__color-badge"
          style={{ backgroundColor: clientColor }}
          title={clientColor}
        />
      )}
      <span className="client-table-cell__code">{clientCode}</span>
    </div>
  );
};

ClientTableCell.propTypes = {
  item: PropTypes.shape({
    clientId: PropTypes.shape({
      code: PropTypes.string,
      color: PropTypes.string,
    }),
  }).isRequired,
};

export default ClientTableCell;


